import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button, Inputs } from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import { responseSelector } from "../utils/helpers/selectors";
import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";
import PYG from "../utils/PYG";

const { Text } = Inputs;

const estadoOptions = () => [
  { value: "ACTIVO", label: "ACTIVO" },
  { value: "INACTIVO", label: "INACTIVO" },
];

const tipoOptions = () => [
  { value: "m", label: "Meses" },
  { value: "d", label: "Dias" },
  { value: "w", label: "Semanas" },
];

function EditPlan({ history, match }) {
  const dispatch = useDispatch();

  const modelUpdatePlan = useSelector((state) => state.updatePlan);
  const modelPlanById = useSelector((state) => state.getPlanById);

  const [descripcion, setDescripcion] = useState("");
  const [precio, setPrecio] = useState("0");
  const [estado, setEstado] = useState("ACTIVO");
  const [groupLabel, setGroupLabel] = useState("reservas");
  const [duracion, setDuracion] = useState("1");
  const [tipoDuracion, setTipoDuracion] = useState("m");
  const [capacidad, setCapacidad] = useState(5);

  useEffect(() => {
    dispatch(controller.getPlanByIdThunk(match.params.id));
  }, []);

  useEffect(() => {
    const { data, error } = responseSelector(modelPlanById);

    if (error) {
      alert(error);
      dispatch(controller.getPlanByIdDuck.actions.clear());
    }
    if (data) {
    
      setTipoDuracion(data.subscriptions.tipoDuracion);
      setDescripcion(data.description);
      setPrecio(data.cost);
      setEstado(data.estado);
      setGroupLabel(data.subscriptions.groupLabel);
      setDuracion(data.subscriptions.duration);
      setCapacidad(data.subscriptions.capacidad);

      dispatch(controller.getPlanByIdDuck.actions.clear());
    }
  }, [modelPlanById]);

  useEffect(() => {
    const { data, error } = responseSelector(modelUpdatePlan);

    if (error) {
      alert(error);
      dispatch(controller.updatePlanDuck.actions.clear());
    }
    if (data) {
      history.push(`/planes/${match.params.localId}`);
      dispatch(controller.updatePlanDuck.actions.clear());
    }
  }, [modelUpdatePlan]);

  function submit() {
    if (
      !descripcion ||
      !tipoDuracion ||
      !estado ||
      precio === "" ||
      precio === null ||
      !duracion ||
      !capacidad
    ) {
      alert("Por favor complete todos los campos");
      return;
    }

    let data = {
      id: match.params.id,
      descripcion,
      estado,
      precio,
      groupLabel: "reservas",
      duracion: duracion,
      tipoDuracion,
      capacidad: capacidad,
    };

    dispatch(controller.updatePlanThunk(data));
  }
  return (
    <Content title="Editar plan" browserTitle="Editar plan" show={false}>
      <Row>
        <Col md="4" mdOffset="4">
          <Box
            title="Editar plan"
            footer={
              <>
                <Button text="Cancelar" onClick={() => history.goBack()} />

                <Button
                  margin={true}
                  type="primary"
                  text="Guardar"
                  pullRight={true}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <ReferenciaObligatorios />

            <SelectInput
              value={estado}
              setValue={setEstado}
              label={<Etiqueta texto="Estado" obligatorio={true} />}
              options={estadoOptions()}
            />

            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Nombre" obligatorio={true} />}
              value={descripcion}
              onChange={(evt) => setDescripcion(evt.target.value)}
            />

            <PYG
              // react-number-format's props
              value={precio}
              isNumericString={true}
              displayType="input"
              onValueChange={(values) => {
                const { formattedValue, value } = values;
                setPrecio(value);
              }}
              decimalScale={0}
              customInput={Text}
              // adminlte-2-react's Text's props
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Precio" obligatorio={true} />}
            />

            <Text
              inputType="number"
              labelPosition="above"
              size="sm"
              label={
                <Etiqueta
                  texto="Sesiones (reservas incluidas)"
                  obligatorio={true}
                />
              }
              value={capacidad}
              onChange={(evt) => setCapacidad(evt.target.value)}
            />

            <SelectInput
              value={tipoDuracion}
              setValue={setTipoDuracion}
              label={<Etiqueta texto="Tipo duración" obligatorio={true} />}
              options={tipoOptions()}
            />

            <Text
              inputType="number"
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Duración" obligatorio={true} />}
              value={duracion}
              onChange={(evt) => setDuracion(evt.target.value)}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default EditPlan;
